import { makeStyles, shorthands, tokens } from "@fluentui/react-components";
import {
    InfoRegular
} from "@fluentui/react-icons";
import { useL10n } from "context/l10n-context";
import { ILocaleStrings } from "loc/locale.interfaces";
import { IScreenPlaceholderProps } from "components/common/screen-placeholder/screen-placeholder.props";
import ScreenPlaceholder from "components/common/screen-placeholder/screen-placeholder";
import Grid from "components/grid/grid";
import { ITableColumn } from "@interfaces/common.interfaces";
import { IApplicationRoleMembershipGridProps } from "./application-role-membership-grid.props";
import { IApplicationRoleMembership } from "@interfaces/settings/permissions.interfaces";
import PrincipalsCell from "components/reports-common/report-results-grid-cells/principals-cell/principals-cell";
import { getAsPrincipal } from "lib/settings/application-roles";
import PrincipalCell from "components/reports-common/report-results-grid-cells/principal-cell/principal-cell";
import { getDirectoryObjectPrincipalTypeKey } from "lib/principals";

const layoutStyles = makeStyles({
    mainWrapper: {
        flexGrow: 1,
        padding: '0 1em'
    }
});

export default function ApplicationRoleMembershipGrid(props: IApplicationRoleMembershipGridProps) {
    const styles = layoutStyles();
    const { t } = useL10n<ILocaleStrings>();

    //
    const cols: Array<ITableColumn<IApplicationRoleMembership>> = [
        {
            key: "objectId", label: t("name"), minWidth: 200,
            renderCell: (key: string, item: IApplicationRoleMembership) => (
                <PrincipalCell principal={getAsPrincipal(item)} />
            )
        },
        {
            key: "memberType", label: t("ppaApplicationRoleMembershipMemberType"), minWidth: 300,
            renderCell: (key: string, item: IApplicationRoleMembership) => (
                <div key={key}>{t(getDirectoryObjectPrincipalTypeKey(item.memberType))}</div>
            )
        },
    ];

    const noItemsScreenPlaceholderProps: IScreenPlaceholderProps = {
        imageUrl: "images/NoUsersImage.png",
        title: t("ppaApplicationRoleMembershipNoItemsTitle"),
        message: t("ppaApplicationRoleMembershipNoItemsMessage")
    }

    return (
        <div className={styles.mainWrapper}>
            {props.items.length === 0 &&
                <ScreenPlaceholder {...noItemsScreenPlaceholderProps} />}
            {props.items.length > 0 &&
                <Grid
                    columns={cols}
                    items={props.items}
                    selectionMode="multiselect"
                    onSelectionChanged={props.onSelectionChanged}
                />}
        </div>
    );
}